var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment } from 'react';
var ScheduleActionDropdown = function (_a) {
    var record = _a.record, handleProcess = _a.handleProcess;
    return (_jsx(Fragment, { children: _jsx("div", __assign({ className: 'd-flex gap-2' }, { children: _jsx("button", __assign({ type: 'button', onClick: function () { return handleProcess(record); }, className: 'btn btn-primary btn-active-light-primary mr-2 btn-sm' }, { children: "Detail" })) })) }));
};
export default ScheduleActionDropdown;
